// frontend/admin-portal/src/components/products/ProductDeleteModal.jsx
import React, { useState } from "react";
import { Modal, Button, Alert } from "@fiberhome/shared-ui";
import { productService } from "../../services/productService";

export default function ProductDeleteModal({
  open,
  product,
  onClose,
  onDeleted,
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    setBusy(true);
    setError("");
    try {
      await productService.remove(product.id);
      onDeleted?.();
      onClose?.();
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Delete Product?"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete} loading={busy}>
            Delete Permanently
          </Button>
        </>
      }
    >
      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}
      <Alert variant="warning" title="This cannot be undone">
        You're about to delete <strong>{product?.name}</strong> ({product?.sku}
        ).
      </Alert>
    </Modal>
  );
}
